import { render, staticRenderFns } from "./PlatformChart.vue?vue&type=template&id=7eb457b2&scoped=true"
import script from "./PlatformChart.vue?vue&type=script&lang=ts"
export * from "./PlatformChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb457b2",
  null
  
)

export default component.exports